import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';
import { MessageCircleReply, EllipsisVertical } from 'lucide-react';
import { Menu } from '@headlessui/react';
import commentToHtml from '../utils/commentToHtml';
import commentCreatedAt from '../utils/commentCreatedAt';
import CommentAvatar from './comment-avatar';
import CommentRoleLabelComponent from './comment-role-label';
import Button from '../../../components/Button';
import GlobalContext from '../../../utils/GlobalContext';

export default function CommentItemComponent({
  comment,
  comment: {
    message,
    createdAt,
    sender,
    sender: { id, fullName, image },
  },
  currentUserId,
  members = [],
  hideReply = false,
  onReply,
  onDelete,
  onEdit,
}) {
  const { locales } = useContext(GlobalContext);
  const resultMessage = useMemo(() => {
    return commentToHtml(message, members, id);
  }, [message, members]);

  return (
    <li className="comment-item">
      <div className="comment-item-header">
        <div className="comment-item-header-avatar">
          <CommentAvatar url={image?.icon?.url} />
        </div>
        <div className="comment-item-header-sender">
          <div
            className={classNames('comment-item-header-sender__full-name', {
              'text-muted-darker': sender?.isDeleted,
            })}
          >
            {fullName}
          </div>
          <CommentRoleLabelComponent
            sender={sender}
            currentUserId={currentUserId}
          />
        </div>

        {id === currentUserId && (
          <Menu>
            <Menu.Button className="bmc-userbar-avatar">
              <EllipsisVertical />
            </Menu.Button>
            <Menu.Items className="bmc-userbar-menu">
              <Menu.Item
                as={Button}
                variant="ghost"
                className="ui-active:bg-muted w-full rounded-none justify-start ui-active:bg-muted"
                onClick={() => onEdit(comment)}
              >
                {locales.chatSystem.edit}
              </Menu.Item>
              <Menu.Item
                as={Button}
                variant="ghost"
                className="ui-active:bg-muted w-full rounded-none justify-start ui-active:bg-muted"
                onClick={() => onDelete(comment)}
              >
                {locales.chatSystem.delete}
              </Menu.Item>
            </Menu.Items>
          </Menu>
        )}
      </div>
      <div className="comment-item-content">
        <div className="comment-item-content__line" />

        <div className="comment-item-message">
          <div
            className="comment-item-message__text"
            dangerouslySetInnerHTML={{ __html: resultMessage }}
          />
          <Button
            className={classNames({
              hidden: hideReply,
            })}
            onClick={() => onReply(comment)}
            variant="ghost"
            size="evenDefault"
            disabled={sender?.isDeleted}
          >
            <MessageCircleReply />
          </Button>
        </div>
        <div className="comment-item-message__created-at">
          {commentCreatedAt(createdAt)}
        </div>
      </div>
    </li>
  );
}
